interface BackgroundImageTriggerProps {
  selectedImage?: string;
  onClick: () => void;
}

export default function BackgroundImageTrigger({ selectedImage, onClick }: BackgroundImageTriggerProps): JSX.Element {
  return (
    <div
      data-testid="image-picker-button"
      className="flex size-full cursor-pointer items-center justify-center overflow-hidden rounded-full border border-slate-300 bg-slate-100"
      onClick={onClick}
    >
      {selectedImage ? (
        <div
          data-testid="image-preview"
          className="size-full bg-cover bg-center"
          style={{ backgroundImage: `url(${selectedImage})` }}
        />
      ) : (
        <div data-testid="image-placeholder" className="h-full w-px rotate-45 bg-slate-300" />
      )}
    </div>
  );
}
